interface Props {
  totalSteps: number;
  currentStep: number;
  items: React.ReactNode[];
  //   setStep: React.Dispatch<React.SetStateAction<number>>;
}

const Stepper = ({ currentStep, items }: Props) => {
  return <>{items[currentStep]}</>;
};

export default Stepper;
